const getSitesData = async ({ domain }) => {
  const response = await fetch(`${process.env.SITES_API_URL}/sites/current`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      domain,
    },
  })

  if (!response.ok) {
    throw new Error("Failed to fetch site data")
  }

  const data = await response.json()
  return data
}

export default getSitesData



// WEBPACK FOOTER //
// ./src/services/SitesApi/getSitesApi.js